/**
 * @generated SignedSource<<5ae6247ef2664b7d3a20752a45519d43>>
 * @relayHash 60da0ad6ab765edda441bc3f12aebccd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4070693c9f65adda0992a2f6996fd799e666f13bed0964d9897f83e792a54394

import type { ConcreteRequest } from 'relay-runtime';
export type getIsAdminFromStoreQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type getIsAdminFromStoreQuery$data = {
  readonly jira: {
    readonly isGlobalAdmin: boolean | null | undefined;
    readonly isProjectAdmin: boolean | null | undefined;
  } | null | undefined;
};
export type getIsAdminFromStoreQuery = {
  response: getIsAdminFromStoreQuery$data;
  variables: getIsAdminFromStoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "alias": "isProjectAdmin",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "permission",
            "value": "ADMINISTER_PROJECTS"
          },
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission"
      },
      {
        "alias": "isGlobalAdmin",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "key",
            "value": "ADMINISTER"
          }
        ],
        "kind": "ScalarField",
        "name": "hasGlobalPermission"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getIsAdminFromStoreQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getIsAdminFromStoreQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "4070693c9f65adda0992a2f6996fd799e666f13bed0964d9897f83e792a54394",
    "metadata": {},
    "name": "getIsAdminFromStoreQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c842842dbba306cb5c1dfd3f0a96b190";

export default node;
